import { TAU, WHITE, circle, glow, polygon, rim } from '../paint';
import type { Ctx, Piece } from '../paint';
import { REFERENCE_RADIUS } from '../textures-looks';

export const UNIT = 2;

export const ELEMENT_COLORS = [0xff7a3d, 0x4fb3ff, 0xe6f4ff, 0xe0a84a] as const;
export const HAIR = 0x2a1a10;

export const HEAD = { along: 2, hair: 1 } as const;
export const COMPASS = { radius: 22, half: 0.62, width: 2, bold: 3, arrow: 5 } as const;

const OUT = 'rgba(4,6,18,.9)';

function units(draw: (ctx: Ctx) => void): (ctx: Ctx) => void {
  return (ctx) => {
    ctx.save();
    ctx.scale(UNIT, UNIT);
    draw(ctx);
    ctx.restore();
  };
}

function torsoPath(ctx: Ctx): void {
  ctx.beginPath();
  ctx.ellipse(0, 0, 8, 13, 0, 0, TAU);
}

function torso(ctx: Ctx): void {
  torsoPath(ctx);
  ctx.fillStyle = '#e4e4e4';
  ctx.fill();
  ctx.beginPath();
  ctx.ellipse(1.5, 0, 4, 8.6, 0, 0, TAU);
  ctx.fillStyle = WHITE;
  ctx.fill();
  torsoPath(ctx);
  rim(ctx, 2);
}

function disc(radius: number, width: number): (ctx: Ctx) => void {
  return (ctx) => {
    circle(ctx, radius);
    ctx.fillStyle = WHITE;
    ctx.fill();
    if (width > 0) {
      rim(ctx, width);
    }
  };
}

function quarter(width: number): (ctx: Ctx) => void {
  return (ctx) => {
    ctx.beginPath();
    ctx.arc(0, 0, COMPASS.radius, -COMPASS.half, COMPASS.half);
    ctx.lineWidth = width;
    ctx.lineCap = 'round';
    ctx.strokeStyle = WHITE;
    ctx.stroke();
  };
}

function arrow(ctx: Ctx): void {
  polygon(ctx, [
    [3, 0],
    [-2, -2.6],
    [-2, 2.6],
  ]);
  ctx.fillStyle = WHITE;
  ctx.fill();
  ctx.lineWidth = 0.7;
  ctx.strokeStyle = OUT;
  ctx.lineJoin = 'round';
  ctx.stroke();
}

function soft(width: number, height: number): Piece {
  return [
    96,
    96,
    REFERENCE_RADIUS,
    (ctx) => {
      glow(ctx, WHITE, 8);
      ctx.fillStyle = WHITE;
      ctx.beginPath();
      ctx.ellipse(0, 0, width, height, 0, 0, TAU);
      ctx.fill();
    },
  ];
}

const COMPASS_SIZE = 2 * (COMPASS.radius + COMPASS.bold) * UNIT;

export const AVATAR_PIECES = {
  torso: [40, 60, REFERENCE_RADIUS, units(torso)],
  hand: [16, 16, REFERENCE_RADIUS, units(disc(2, 1.1))],
  head: [32, 32, REFERENCE_RADIUS, units(disc(6.2, 1.6))],
  hair: [24, 24, REFERENCE_RADIUS, units(disc(4.6, 0))],
  quarter: [COMPASS_SIZE, COMPASS_SIZE, REFERENCE_RADIUS, units(quarter(COMPASS.width))],
  boldQuarter: [COMPASS_SIZE, COMPASS_SIZE, REFERENCE_RADIUS, units(quarter(COMPASS.bold))],
  arrow: [16, 16, REFERENCE_RADIUS, units(arrow)],
  orb: [16, 16, REFERENCE_RADIUS, units(disc(1.6, 0))],
  shadow: soft(16, 26),
} satisfies Record<string, Piece>;
